import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { DELETE_MODELS } from './constants';
import {
  DeleteModelsSuccess,
  DeleteModelsError,
  DeleteModelsDataActionTypes,
  DeleteModelsState,
} from './types';

const initialState: DeleteModelsState = {
  status: idle,
  entities: {},
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: DeleteModelsDataActionTypes,
  ): DeleteModelsState => {
    switch (action.type) {
      case DELETE_MODELS + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case DELETE_MODELS + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as DeleteModelsSuccess).payload;
        break;
      }
      case DELETE_MODELS + FAILURE: {
        draft.status = rejected;
        draft.error = (action as DeleteModelsError).error;
        break;
      }
      case DELETE_MODELS + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
